import React, { useState, useEffect } from 'react';
import { Box, CardMedia, Fade } from '@mui/material';
import { carouselItems, carouselSettings } from '../config/carouselConfig';
import { InAppBrowser } from '@capacitor/inappbrowser';
import { Capacitor } from '@capacitor/core';

// Function to open URLs in external browser
const openExternalUrl = async (url) => {
    if (Capacitor.isNativePlatform()) {
        try {
            await InAppBrowser.openInExternalBrowser({ url });
        } catch (error) {
            console.error('Error opening external URL:', error);
            window.open(url, '_blank');
        }
    } else {
        window.open(url, '_blank');
    }
};

const ImageCarousel = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fadeIn, setFadeIn] = useState(true);

    useEffect(() => {
        if (carouselItems.length > 1) {
            const interval = setInterval(() => {
                // Fade out
                setFadeIn(false);
                
                // After fade out, change image and fade in
                setTimeout(() => {
                    setCurrentIndex((prevIndex) => (prevIndex + 1) % carouselItems.length);
                    setFadeIn(true);
                }, carouselSettings.transitionDuration);
            }, carouselSettings.interval);

            return () => clearInterval(interval);
        }
    }, []);

    if (carouselItems.length === 0) {
        return null;
    }

    const currentItem = carouselItems[currentIndex];
    const hasUrl = currentItem.url && currentItem.url.trim() !== '';

    const handleClick = () => {
        if (hasUrl) {
            openExternalUrl(currentItem.url);
        }
    };

    return (
        <Box 
            sx={{ 
                width: '100%', 
                height: '100%', 
                position: 'relative',
                overflow: 'hidden',
                cursor: hasUrl ? 'pointer' : 'default',
                borderRadius: 1
            }}
            onClick={handleClick}
        >
            <Fade in={fadeIn} timeout={carouselSettings.transitionDuration}>
                <CardMedia
                    component="img"
                    image={currentItem.image}
                    alt={currentItem.alt || `Ad ${currentIndex + 1}`}
                    sx={{
                        width: '100%',
                        height: '100%',
                        objectFit: 'contain',
                        borderRadius: 1
                    }}
                />
            </Fade>
        </Box>
    );
};

export default ImageCarousel;
